//import { URLASSOLUTO } from './variables';
import Swal from './sweetalert2';
import boxheight from './boxheight';
//import './jquery.flexdatalist'; // messo script localmente perchè non funziona da node_modules...

document.addEventListener('DOMContentLoaded', function () {

    //console.log(URLASSOLUTO);

    // fade out background preloader
    // $("#preload").fadeOut();

    // sameheight
    let sameheight = document.querySelectorAll(".sameheight");
    boxheight(sameheight);

    let mostraCalendario = document.querySelector(".mostraCalendario");
    let nascondiCalendario = document.querySelector(".nascondiCalendario");
    if (mostraCalendario) {
        mostraCalendario.addEventListener("click", (e) => {
            nascondiCalendario.classList.toggle("hidden");
        });
    }

    // funzione che chiede la conferma all'utente prima di cliccare il button
    let cancellaAsk = document.querySelector(".cancellaAsk");
    if (cancellaAsk) {
        cancellaAsk.addEventListener("submit", (e, data) => {
            // invio form
            if (data) {
                if (data.invia) return;
            }
            e.preventDefault();

            Swal.fire({
                title: "Sei sicuro?",
                html: `Questo elemento verrà cancellato`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si, cancella!",
                cancelButtonText: 'Annulla'
            }).then(result => {

                if (result.value == true) {
                    this.dispatchEvent(new Event("submit", [{ 'invia': true }]));
                }
            });
        });
    }

    // ricerca libera
    const ricercaLibera = document.querySelector("#formRicerca");
    const ricercaLiberaMobile = document.querySelector("#formRicercaMobile");
    const ricercaVeloce = document.querySelector("#ricercaVeloce");
    const ricercaVeloceMobile = document.querySelector("#ricercaVeloceMobile");
    if (ricercaLibera) {
        ricercaLibera.addEventListener("submit", (e) => {
            e.preventDefault();
            // invio form
            let ricercaParola = ricercaVeloce.value;
            if (!ricercaParola || ricercaParola.length < 3) {
                return;
            }

            ricercaLibera.submit();
        });
    }
    if (ricercaLiberaMobile) {
        ricercaLiberaMobile.addEventListener("submit", (e) => {
            e.preventDefault();
            // invio form
            let ricercaParola = ricercaVeloceMobile.value;
            if (!ricercaParola || ricercaParola.length < 3) {
                return;
            }

            ricercaLiberaMobile.submit();
        });
    }

    const iconaRicercaMobile = document.querySelector('.ricerca-veloce-top');
    const divRicercaMobile = document.querySelector('.showCerca');
    iconaRicercaMobile.addEventListener("click", (e) => {
        divRicercaMobile.classList.toggle("hidden");
    });

    // apri modal mostra prossimi corsi docenti
    const mostraProssimiCorsi = document.querySelectorAll(".showModalCorsi");
    if (mostraProssimiCorsi) {

      mostraProssimiCorsi.forEach((item) => {
        item.addEventListener("click", (e) => {
          /* console.log(e.target.nextElementSibling); */
          Swal.fire({
            html: e.target.nextElementSibling.innerHTML,
            cancelButtonText: 'Chiudi',
            customClass: {
              'container': 'docentimodal'
            }
          });
        });
      });

    }
});

window.addEventListener('resize', event => {
    // sameheight
    let sameheight = document.querySelectorAll(".sameheight");
    boxheight(sameheight);
});